module.exports = __webpack_public_path__ + "media/images/nocampaign-mobile-b7c24ced3ad00319f9d0ab2d3fa187d2.jpg";